import { Avatar, Col, Empty, Row, Skeleton } from 'antd'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Classcard from './classcard/classcard'
import { RootState } from '../../../../store/store'
import { useSelector } from 'react-redux'
import { openNotificationWithIcon } from '../../../../utils/helper'
import { getStudentClasses } from '../../../../api/class/class'

const leaderboardData: any[] = []

const Studentclasses = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()

	const [loading, setLoading] = useState(false)
	const [data, setData] = useState([])

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	const requestParams = useMemo(() => {
		return {

		}

		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'Classes'
			}
		})

		// eslint-disable-next-line
	}, [])


	const fetchClasses = useCallback(
		async () => {
			try {
				setLoading(true)
				const res = await getStudentClasses(requestParams, user?._id)
				const { data } = res?.data
		
				setData(data)
				setLoading(false)
			} catch (error: any) {
				setLoading(false)
				if (error?.response) {
					openNotificationWithIcon('error', 'Get Classes', `${error?.response?.data?.message || 'Something went wrong'}`)
				} else {
					openNotificationWithIcon('error', 'Get Classes', 'Something went wrong')
				}
			}
		},

		// eslint-disable-next-line 
		[requestParams],
	)


	useEffect(() => {
		fetchClasses()

	}, [fetchClasses])

	return (
		<div className='h-screen pr-10 mt-4 mb-10'>
			<Row gutter={32}>
				<Col lg={14} md={24} xs={24}>
					<div>
						{
							loading ?
								<>
									{
										[1, 2, 3,].map((item) => (
											<div key={`loading-class-${item}`}>
												<Skeleton.Button
													active={true}
													size={'large'}
													shape={'square'}
													block={true}
													style={{
														height: '12.5rem',
														marginBottom: '1.8rem',
														borderRadius: '1rem',
														marginRight: '1rem'
													}}
												/>
											</div>
										))
									}
								</>
								:
								<>
									{
										data.length === 0 ?
											<>
												<Empty
													description={`You currently haven't joined any class.`}
												/>
											</>
											:
											data.map((item: any) => (
												<Classcard
													details={item}
												/>
											))
									}
								</>
						}
					</div>
				</Col>
				<Col lg={10} md={24} xs={24}>
					<div>
						<p className='mb-2 text-xl font-bold capitalize text-appcolorblackfainteleven'>
							Classroom Leaderboard
						</p>

						<p className='mb-2 text-base'>See how you’re doing in your class</p>

						<div>
							{
								leaderboardData.length === 0 ?
									<>
										<p className='text-appcolorblackfainteleven tex-base'>Leaderboard data currently unavailable</p>
									</>
									:

									leaderboardData.map((item) => (
										<div
											key={`fpt-${item}`}
											className={`flex items-center justify-between p-4 hover:bg-appcolororangefaint hover:rounded-[10px] mb-0  `}>
											<div className='flex items-center'>
												<p className='rounded-[7px] bg-appcolorpurplefour py-[0.2rem] px-[0.6rem] mr-2 text-appcolorwhite'>
													1
												</p>

												<div className='flex items-center'>
													<Avatar
														src="/img/vectors/userfemale.svg"
														style={{
															border: '2px solid #FBE0FF',
															borderRadius: '50%',
															width: '3rem',
															height: '3rem',
														}}
													/>

													<div className='ml-3'>
														<p className='mb-1 text-base font-semibold text-appcolorblack'>Ella</p>
														<p className='text-base text-appcolorblack  font-semibold opacity-[0.5]'>ellie123</p>
													</div>
												</div>
											</div>


											<div className=''>
												<p className='mb-1 text-base font-semibold text-appcolorblack'>
													40000FP
												</p>
											</div>
										</div>
									))
							}
						</div>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default Studentclasses